{
  "en": {
    "staffingRecovery": {
      "recoverInformation": "Recover information",
      "submissionError": "Failed to submit the staffing recovery request",
      "submissionSuccess": "Staffing analysis started. The staffing table will be updated automatically.",
      "completionError": "Staffing analysis failed. Please try again.",
      "noDocumentsSelected": "Please select at least one document",
      "tooManyDocuments": "Please select at most {max} documents"
    }
  },
  "fr": {
    "staffingRecovery": {
      "recoverInformation": "Récupération des informations",
      "submissionError": "Échec de l'envoi de la requête de récupération des effectifs",
      "submissionSuccess": "Analyse des effectifs lancée. Le tableau des effectifs sera mis à jour automatiquement.",
      "completionError": "L'analyse des effectifs a échoué. Veuillez réessayer.",
      "noDocumentsSelected": "Veuillez sélectionner au moins un document",
      "tooManyDocuments": "Veuillez sélectionner au maximum {max} documents"
    }
  },
  "nl": {
    "staffingRecovery": {
      "recoverInformation": "Informatie ophalen",
      "submissionError": "Fout bij het indienen van het verzoek om personeelsgegevens op te halen",
      "submissionSuccess": "Analyse van de bezetting gestart. De bezettingstabel wordt automatisch bijgewerkt.",
      "completionError": "Analyse van de bezetting mislukt. Probeer het opnieuw.",
      "noDocumentsSelected": "Selecteer ten minste één document",
      "tooManyDocuments": "Selecteer maximaal {max} documenten"
    }
  }
}
